import axios from 'axios';

// 创建axios实例
const api = axios.create({
  baseURL: '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器 - 添加认证token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理token过期等错误
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      
      // 如果token过期或无效，清除本地存储并跳转到登录
      if (status === 401) {
        localStorage.removeItem('token');
        // 可以在这里添加全局状态更新或重定向逻辑
        if (data.code === 'TOKEN_EXPIRED' || data.code === 'INVALID_TOKEN') {
          console.log('Token已过期或无效，请重新登录');
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;